import { render, staticRenderFns } from "./PermissionManagement.vue?vue&type=template&id=3ea48fe8"
import script from "./PermissionManagement.vue?vue&type=script&lang=js"
export * from "./PermissionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports